var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTabIconBoards(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 45.145 45.145",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_01",
    "data-name": 1,
    transform: "translate(-1.25 -1.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22634",
    "data-name": "Path 22634",
    d: "M15.988,1.25H7.509C3.3,1.25,1.25,3.207,1.25,7.234V40.41c0,4.027,2.047,5.984,6.259,5.984h8.479c4.212,0,6.259-1.957,6.259-5.984V7.234c0-4.027-2.047-5.984-6.259-5.984ZM19.1,40.41c0,2.127-.449,2.835-3.11,2.835H7.509c-2.66,0-3.11-.708-3.11-2.835V7.234c0-2.127.449-2.835,3.11-2.835h8.479c2.66,0,3.11.708,3.11,2.835Z",
    transform: "translate(0)",
    fill: "#9797bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22635",
    "data-name": "Path 22635",
    d: "M27.488,1.25H19.009c-4.212,0-6.259,1.957-6.259,5.984V25.712c0,4.025,2.047,5.984,6.259,5.984h8.479c4.212,0,6.259-1.959,6.259-5.984V7.234c0-4.027-2.047-5.984-6.259-5.984ZM30.6,25.712c0,2.127-.449,2.835-3.11,2.835H19.009c-2.66,0-3.11-.708-3.11-2.835V7.234c0-2.127.449-2.835,3.11-2.835h8.479c2.66,0,3.11.708,3.11,2.835Z",
    transform: "translate(12.647)",
    fill: "#9797bd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabIconBoards);
export default __webpack_public_path__ + "static/media/TabIconBoards.721dba5690a35e2b94c25c8ceb6b7d00.svg";
export { ForwardRef as ReactComponent };